import React, { useState } from 'react';
import { Box, Button, Container, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import constants from "../utils/constants";
import locales from '../locales.json';
import { useLang } from "../context/LangContext";

const { BACKEND_URL } = constants;

function SignUp() {
  const { lang } = useLang();
  const { signup_page } = locales;

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password || !formData.confirmPassword) {
      setError(signup_page.all_fields_required[lang]);
      return;
    }

    if (formData.password.length < 6) {
      setError(signup_page.password_too_short[lang]);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError(signup_page.passwords_not_match[lang]);
      return;
    }

    try {
      const data = await axios.post(
        `${BACKEND_URL}/authentication/signup`,
        {
          email: formData.email,
          password: formData.password,
          lang: (navigator.language || navigator.userLanguage).split('-')[0],
        }
      );

      if (data.error) {
        alert(`${signup_page.error_prefix[lang]} ${data.message}`);
      } else {
        setError('');
        navigate('/email-validation');
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setError(error.response.data.message);
      } else {
        setError(error.message);
      }
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: { xs: '100vh', md: 'calc(100vh - 64px)' }, // Plein écran sur mobile
        px: { xs: 1, sm: 2, md: 0 }, // Padding horizontal responsive
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#f9f9f9',
          padding: { xs: '20px', sm: '32px' }, // Padding adapté
          borderRadius: '16px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          width: '100%',
          maxWidth: '400px',
          mx: 'auto',
        }}
      >
        <Typography variant="h4" gutterBottom align="center" sx={{ fontSize: { xs: '1.7rem', md: '2rem' } }}>
          {signup_page.title[lang]}
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label={signup_page.email_label[lang]}
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
          />
          <TextField
            fullWidth
            label={signup_page.password_label[lang]}
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
          />
          <TextField
            fullWidth
            label={signup_page.confirm_password_label[lang]}
            name="confirmPassword"
            type="password"
            value={formData.confirmPassword}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
          />
          {error && (
            <Typography color="error" sx={{ marginTop: '8px', fontSize: { xs: '0.95rem', md: '1rem' } }}>
              {error}
            </Typography>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              marginTop: '24px',
              padding: { xs: '10px 0', md: '12px 0' },
              borderRadius: '24px',
              fontSize: { xs: '1rem', md: '1.1rem' },
            }}
          >
            {signup_page.sign_up_button[lang]}
          </Button>
        </form>
      </Box>
    </Container>
  );
}

export default SignUp;
